import { observable } from "mobx";

export default class PositionModalStore {
    @observable isVisible = false;
}